import { deleteCookie } from '@amagimedia/api-client';
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { generateTokenApi } from './apis/auth';
import {
  BACKEND_API_URL,
  BACKEND_API_URL_V2,
  REFRESH_ACCESS_TOKEN_TIMER_KEY,
} from './constants/strings';
import { shouldNavigateToSignInPage } from './utils';
import { gotoSignInPage } from './utils/urls';
const defaultErrorMessage = {
  response: {
    data: {
      error: 'Something happened. Please try again later',
    },
  },
};
function rejectedResponseInterceptor(err: AxiosError) {
  if (!err.response?.status) {
    return Promise.reject(defaultErrorMessage);
  }
  if (err.response.status !== 401) {
    return Promise.reject(err);
  }
  const originalRequest = err.config as AxiosRequestConfig & {
    _retry: boolean;
  };
  // if tried to refresh failed before, then reject
  if (originalRequest._retry) {
    if (shouldNavigateToSignInPage()) {
      deleteCookie(REFRESH_ACCESS_TOKEN_TIMER_KEY);
      gotoSignInPage({
        shouldSavePreviousRoute: true,
      });
    }
  }
  originalRequest._retry = true;
  return generateTokenApi(originalRequest.baseURL as string)
    .then((res) => {
      if (res.status === 200) {
        return axios(originalRequest);
      }
    })
    .catch(() => {
      if (shouldNavigateToSignInPage()) {
        deleteCookie(REFRESH_ACCESS_TOKEN_TIMER_KEY);
        gotoSignInPage({
          shouldSavePreviousRoute: true,
        });
      }
      return Promise.reject();
    });
}
interface ICreateClientOptions {
  baseURL: string;
  withCredentials: boolean;
}
export function createApiClient(options: ICreateClientOptions): AxiosInstance {
  const ApiClient = axios.create({
    baseURL: options.baseURL,
    withCredentials: options.withCredentials,
  });
  ApiClient.interceptors.request.use(
    (config) => config,
    () => Promise.reject(defaultErrorMessage),
  );
  ApiClient.interceptors.response.use(
    (response) => response,
    rejectedResponseInterceptor,
  );
  return ApiClient;
}
export const ApiClient = createApiClient({
  baseURL: BACKEND_API_URL,
  withCredentials: true,
});
export const ApiClientV2 = createApiClient({
  baseURL: BACKEND_API_URL_V2,
  withCredentials: true,
});
